export const ALTERNATE_RX_PRODUCT_VALUE = 1036;
